import { JsonValue } from 'type-fest';

import getByPath from '../getByPath/index.ts';

const globals = (
  typeof window !== 'undefined'
    ? ((window as { aglmd?: Record<string, JsonValue> })?.aglmd ?? {})
    : {}
) as Record<string, JsonValue>;

/**
 * Allows retrieving data that was injected into the page on serving the page
 *
 * @param key The key of the server preloaded application state
 * @param defaultValue The value to use if the key was not found or provided
 */
export default function getGlobalParam<T>(key: string, defaultValue?: T): T {
  if (Object.prototype.hasOwnProperty.call(globals, key)) {
    return Object.freeze(globals[key]) as T;
  }

  const value = getByPath(globals, key, defaultValue) as T | undefined;

  if (value === undefined) {
    throw new Error(`missing required global: ${key}`);
  }

  return Object.freeze(value) as T;
}
